module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('mu-card', {
    staticClass: "pulse-ranges"
  }, [_c('mu-card-text', {
    staticClass: "top-label"
  }, [_vm._v("Your heart rate statistics for " + _vm._s(_vm.moment(_vm.data.date).format('Do MMM YY')))]), _vm._v(" "), (_vm.isLoading) ? _c('mu-card-text', {
    staticClass: "top-label"
  }, [_vm._v(_vm._s(_vm.$t('message.loadingText')))]) : _vm._e(), _vm._v(" "), _c('mu-card-text', [(!_vm.isLoading) ? _c('mu-row', [_c('mu-col', {
    attrs: {
      "width": "33",
      "tablet": "33",
      "desktop": "33"
    }
  }, [_c('radial-progress', {
    attrs: {
      "data-id": "radial-min",
      "value": _vm.data.min,
      "color": "#9781F0"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "center"
  }, [_vm._v("\n          MIN\n        ")])], 1), _vm._v(" "), _c('mu-col', {
    attrs: {
      "width": "33",
      "tablet": "33",
      "desktop": "33"
    }
  }, [_c('radial-progress', {
    attrs: {
      "data-id": "radial-max",
      "value": _vm.data.max,
      "color": "#F1696B"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "center"
  }, [_vm._v("\n          MAX\n        ")])], 1), _vm._v(" "), _c('mu-col', {
    attrs: {
      "width": "33",
      "tablet": "33",
      "desktop": "33"
    }
  }, [_c('radial-progress', {
    attrs: {
      "data-id": "radial-avg",
      "value": _vm.data.avg,
      "color": "#6EDEEA"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "center"
  }, [_vm._v("\n          AVG\n        ")])], 1)], 1) : _vm._e()], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-54a452c9","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Tracking/Visualizations/Pulse/Pulse.vue
// module id = 3731
// module chunks = 1